import React from "react";
import { Card, RiskStatusIcon } from "@sscs/ui";
import { PolicyAudit } from "../../common";
import styles from "./licenseDetails.module.scss";
const getLicenseNoticeLabel = (status, notice) => {
    let statusText = "Allowed";
    if (status === "warning") {
        statusText = "Warn when";
    }
    else if (status === "fail") {
        statusText = "Restricted";
    }
    switch (notice) {
        case "license_present":
            return `${statusText} inclusion of software components and dependencies with this license`;
        case "linking_dynamic":
            return `${statusText} dynamic linking to dependencies with this license`;
        case "linking_package":
            return `${statusText} inclusion of software packages with this license`;
        case "linking_static":
            return `${statusText} static linking to dependencies with this license`;
        default:
            /* Being defensive and following good practice to have a default case...
             * Note, however, it really should never happen because data is coming from TC where C++
             * ensures there cannot be other properties on the notice object:
             * https://github.rl.lan/core/titanium_core/blob/develop/core/include/core/sdlc/schema.hpp#L1249.
             * */
            if (!PRODUCTION) {
                // eslint-disable-next-line no-console
                console.warn(`Unexpected parameter encountered: ${notice}.`);
            }
            return "unknown";
    }
};
const LicenseNoticeAudit = ({ license, }) => {
    const restrictionsCount = Object.values(license.notice).filter((value) => value !== "pass").length;
    return (React.createElement("div", { className: styles["notice-audit"] },
        React.createElement(Card.Card, null,
            React.createElement(Card.Title, null, `${restrictionsCount === 0 ? "No" : restrictionsCount} Configured license restriction${restrictionsCount !== 1 ? "s" : ""}`),
            React.createElement(Card.Content, null,
                React.createElement("ul", { className: styles.restrictions }, Object.entries(license.notice).map(([key, value]) => (React.createElement("li", { key: key, className: styles["restriction-notice"] },
                    React.createElement(RiskStatusIcon, { status: value, disabled: false }),
                    React.createElement("span", null, getLicenseNoticeLabel(value, key)))))))),
        license.audit.present && React.createElement(PolicyAudit, { audit: license.audit })));
};
export default LicenseNoticeAudit;
//# sourceMappingURL=LicenseNoticeAudit.js.map